import { createMobxStoreProvider } from "src/common/factories/createMobxStoreProvider.tsx";
import type { DataGridStore } from "./DataGridStore.ts";

export const { useStore: useDataGridStore, Provider: DataGridStoreProvider } =
  createMobxStoreProvider<DataGridStore>("DataGrid");
